import { render, staticRenderFns } from "./VersionAuthHintModal.vue?vue&type=template&id=627920d6&scoped=true"
import script from "./VersionAuthHintModal.vue?vue&type=script&lang=ts"
export * from "./VersionAuthHintModal.vue?vue&type=script&lang=ts"
import style0 from "./VersionAuthHintModal.vue?vue&type=style&index=0&id=627920d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627920d6",
  null
  
)

export default component.exports